<template>
  <div>
    <div class="columns">
      <div class="column is-9">
        <h5 class="is-size-5-desktop has-text-centered">
          {{ data.nombre }}
        </h5>
      </div>
      <div class="column is-3">
        <b-button type="is-info" icon-left="plus" @click="agregarUsuarioZona">
          Agregar
        </b-button>
      </div>
    </div>
    <div class="box listado-pedidos" :style="{ height: `${alto - 80}px` }">
      <zona-item
        v-for="(usuario, index) in usuarios"
        :key="`usuario-${data.id}-${index}`"
        :usuario="usuario"
        :zona="data"
        @remove="quitarUsuarioHandle"
      />
    </div>
  </div>
</template>

<script>
import ZonaItem from '@/components/configurador/usuariosZona/ZonaItem.vue'
import { zonaService } from '@/services'

export default {
  name: 'Zona',
  components: {
    ZonaItem
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    alto: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      usuarios: []
    }
  },
  watch: {
    data(newVal) {
      if (newVal.actualizarUsuarios) {
        this.getUsuarios()
      }
    }
  },
  mounted() {
    this.getUsuarios()
  },
  methods: {
    getUsuarios() {
      return zonaService
        .getUsuariosByZona(this.data.id)
        .then((response) => (this.usuarios = response.data))
        .catch((error) => this.procesarError(error))
    },
    agregarUsuarioZona() {
      this.$emit('open-modal', this.data)
    },
    quitarUsuarioHandle(payload) {
      this.usuarios = this.usuarios.filter((item) => item.id !== payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.listado-pedidos {
  margin-top: 20px;
  overflow-x: hidden;
}
</style>
